<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-会议预约-添加
    -->
    <el-dialog
    title="添加会议预约"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
    
      <el-form-item label="会议预约名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入会议预约名称" class="max-w460"></el-input>
      </el-form-item>
        <el-form-item label="日期" prop="date">
        <el-date-picker
          v-model="form.date"
          type="date"
          placeholder="请选择日期"
          class="max-w460"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      
      <!-- 完善的时段选择 -->
      <el-form-item label="时段" prop="slots">
        <div class="time-range">
          <el-time-select
            v-model="form.slots.start"
            placeholder="开始时间"
            class="max-w200"
            :picker-options="{
              start: '05:00',
              step: '00:30',
              end: '23:00'
            }"
          ></el-time-select>
          <span class="time-separator">至</span>
          <el-time-select
            v-model="form.slots.end"
            placeholder="结束时间"
            class="max-w200"
            :picker-options="{
              start: '05:30',
              step: '00:30',
              end: '23:00'
            }"
          ></el-time-select>
        </div>
      </el-form-item>
        <el-form-item label="会议室" prop="boardroom">
        <el-input v-model="form.boardroom" placeholder="请输入会议室名称" class="max-w460"></el-input>
      </el-form-item>
      
      
      <el-form-item label="价格" prop="price">
        <el-input v-model="form.price" placeholder="请输入价格" class="max-w460"></el-input>
      </el-form-item>
      
    
      <!-- 完善的状态选择 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status" class="max-w460">
          <el-radio label="0">待审核</el-radio>
          <el-radio label="1">已通过</el-radio>
          <el-radio label="2">已取消</el-radio>
        </el-radio-group>
      </el-form-item>

    
      
      <el-form-item label="会议预约须知">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
  </div>
</el-dialog>
  
</template>

<script>
import Metting_aApi from '@/api/metting_a.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        price: '',
        status: '', // 默认状态为待审核
        date: '',
        // 完善时段数据结构
        slots: {
          start: '',
          end: ''
        },
        boardroom: '',
        name: '',
        code: 'custom',
        sort: 50,
        intro: ""
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入会议预约名称', trigger: 'blur' }],

        boardroom: [{ required: true, message: '请输入会议室名称', trigger: 'blur' }],
        date: [{ required: true, message: '请选择日期', trigger: 'change' }],
        'slots.start': [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        'slots.end': [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
   
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    chooseCategory() {
      this.iscategorya = true;
    },
    
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type":"" });
    },
    
    cancelFunc() { // 取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      
      // 验证时段的有效性
      if (form.slots.start && form.slots.end && form.slots.start >= form.slots.end) {
        self.$message({
          message: "结束时间必须晚于开始时间",
          type: 'error'
        });
        return;
      }
      
      form.intro = this.$refs.ue.getUEContent();
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          // 格式化时段数据为后端需要的格式
          const submitForm = {
            ...form,
            slots: `${form.slots.start}-${form.slots.end}`
          };
          
          Metting_aApi.add(submitForm, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, "type":"" });
    },
    
    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(images) {
      // 处理上传的图片逻辑
      console.log('上传的图片:', images);
      this.isProductUpload = false;
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

/* 时段选择样式 */
.time-range {
  display: flex;
  align-items: center;
  gap: 10px;
}

.time-separator {
  color: #666;
  padding: 0 5px;
}

.max-w200 {
  width: 200px !important;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/metting_a/index/part/add.vue